import React from "react";
import * as FaIcons from "react-icons/fa";
import * as AiIcons from "react-icons/ai";
import * as IoIcons from "react-icons/io";
import * as RiIcons from "react-icons/ri";



export const SidebarData = [
    {
        title: 'STARTSEITE',
        path: '/',
       /*icon: <AiIcons.AiFillHome />,*/
        cName: 'nav-text',
        mcName: 'nav-items'
    },
    {
        title: 'WETTER',
        iconClosed: <RiIcons.RiArrowLeftSFill/>,
        iconOpened: <RiIcons.RiArrowDownSFill />,
        cName: 'nav-text',
        subNav: [
            {
                title: 'Fürstenfeld',
                path:'/wetter/fuerstenfeld'
            },
            {
                title: 'Gippel',
                path:'/wetter/gippel'
            },
            {
                title: 'Jochberg',
                path:'/wetter/jochberg'
            },
            {
                title: 'Klausen-Leopoldsdorf',
                path:'/wetter/klausen-leopoldsdorf'
            },
            {
                title: 'Kollerhube',
                path:'/wetter/kollerhube'
            },
            {
                title: 'Matzen',
                path:'/wetter/matzen'
            },
            {
                title: 'Mondsee',
                path:'/wetter/mondsee'
            },
            {
                title: 'Mürzzuschlag',
                path:'/wetter/muerzzuschlag'
            },
            {
                title: 'Murau',
                path:'/wetter/murau'
            },
            {
                title: 'Neupölla',
                path:'/wetter/neupoella'
            },
            {
                title: 'Unterpullendorf',
                path:'/wetter/unterpullendorf'
            },
            {
                title: 'Wien Schönbrunn',
                path:'/wetter/wien-schoenbrunn'
            }
        ]
    },
    {
        title: 'BODENFEUCHTE',
        iconClosed: <RiIcons.RiArrowLeftSFill/>,
        iconOpened: <RiIcons.RiArrowDownSFill />,
        cName: 'nav-text',
        subNav: [
            {
                title: 'Fürstenfeld',
                path:'/bodenfeuchte/fuerstenfeld'
            },
            {
                title: 'Gippel',
                path:'/bodenfeuchte/gippel'
            },
            {
                title: 'Jochberg',
                path:'/bodenfeuchte/jochberg'
            },
            {
                title: 'Klausen-Leopoldsdorf',
                path:'/bodenfeuchte/klausen-leopoldsdorf'
            },
            {
                title: 'Kollerhube',
                path:'/bodenfeuchte/kollerhube'
            },
            {
                title: 'Matzen',
                path:'/bodenfeuchte/matzen'
            },
            {
                title: 'Mondsee',
                path:'/bodenfeuchte/mondsee'
            },
            {
                title: 'Mürzzuschlag',
                path:'/bodenfeuchte/muerzzuschlag'
            },
            {
                title: 'Murau',
                path:'/bodenfeuchte/murau'
            },
            {
                title: 'Unterpullendorf',
                path:'/bodenfeuchte/unterpullendorf'
            },{
                title: 'Weitra',
                path:'/bodenfeuchte/weitra'
            }
            
        ]
    },
    {
        title: 'BODENTEMPERATUR',
        iconClosed: <RiIcons.RiArrowLeftSFill/>,
        iconOpened: <RiIcons.RiArrowDownSFill />,
        cName: 'nav-text',
        subNav: [
            {
                title: 'Fürstenfeld',
                path:'/bodentemperatur/fuerstenfeld'
            },
            {
                title: 'Gippel',
                path:'/bodentemperatur/gippel'
            },
            {
                title: 'Jochberg',
                path:'/bodentemperatur/jochberg'
            },
            {
                title: 'Klausen-Leopoldsdorf',
                path:'/bodentemperatur/klausen-leopoldsdorf'
            },
            {
                title: 'Kollerhube',
                path:'/bodentemperatur/kollerhube'
            },
            {
                title: 'Matzen',
                path:'/bodentemperatur/matzen'
            },
            {
                title: 'Mondsee',
                path:'/bodentemperatur/mondsee'
            },
            {
                title: 'Mürzzuschlag',
                path:'/bodentemperatur/muerzzuschlag'
            },
            {
                title: 'Murau',
                path:'/bodentemperatur/murau'
            },
            {
                title: 'Unterpullendorf',
                path:'/bodentemperatur/unterpullendorf'
            },
            {
                title: 'Weitra',
                path:'/bodentemperatur/weitra'
            }
        ]
    },
    {
        title: 'BAUMUMFANG',
        iconClosed: <RiIcons.RiArrowLeftSFill/>,
        iconOpened: <RiIcons.RiArrowDownSFill />,
        cName: 'nav-text',
        subNav: [
            {
                title: 'Jochberg',
                path:'/baumumfang/jochberg'
            },
            {
                title: 'Klausen-Leopoldsdorf',
                path:'/baumumfang/klausen-leopoldsdorf'
            },
            {
                title: 'Mondsee',
                path:'/baumumfang/mondsee'
            },
            {
                title: 'Mürzzuschlag',
                path:'/baumumfang/muerzzuschlag'
            },
            {
                title: 'Murau',
                path:'/baumumfang/murau'
            },
            {
                title: 'Unterpullendorf',
                path:'/baumumfang/unterpullendorf'
            }
        ]
    },
    
    {
        title: ' KONTAKT',
        path: '/contact',
       /* icon: <FaIcons.FaEnvelopeOpenText />,*/
        cName: 'nav-text'
    },
    {
        title: ' IMPRESSUM',
        path: '/impressum',
       /* icon: <AiIcons.AiFillProject />,*/
        cName: 'nav-text last',
        mcName: 'nav-items'
    }
]